<template>
    <div
        @click.once="unlockAudioOnUserInteraction"
        @keydown.once="unlockAudioOnUserInteraction"
    >
        <v-app-bar class="bar" app color="#1A3958" dark height="40px">
            <div class="d-flex align-center">
                <v-app-bar-nav-icon
                    v-if="VUETIFY_BREAKPOINT.mobile"
                    class="mr-4"
                    @click.stop="drawer = !drawer"
                ></v-app-bar-nav-icon>
                <v-img src="@assets/logo_icon.png" width="25"></v-img>

                <v-toolbar-title class="ml-4 mr-4">{{
                    pkTitle
                }}</v-toolbar-title>
            </div>
            <template v-if="!VUETIFY_BREAKPOINT.mobile">
                <a
                    class="mt-0 mb-0"
                    v-if="showMenuButton"
                    @click="() => moveDiv(-1)"
                >
                    <v-icon :color="disableToMoveLeft ? 'grey' : 'white'"
                        >mdi-menu-left</v-icon
                    >
                </a>
                <div class="scrollmenu" id="timeDiv">
                    <CurrentLiveTime :name="'NY'" :DST="true" />
                    <CurrentLiveTime :name="'LDN'" :DST="false" />
                    <CurrentLiveTime :name="'MT'" :DST="false" />
                    <CurrentLiveTime :name="'JKT'" :DST="true" />
                    <CurrentLiveTime :name="'BJ'" :DST="true" />
                    <CurrentLiveTime :name="'SYD'" :DST="true" />
                </div>
                <v-spacer></v-spacer>
                <a
                    class="mt-0 mb-0"
                    v-if="showMenuButton"
                    @click="() => moveDiv(1)"
                >
                    <v-icon :color="disableToMoveRight ? 'grey' : 'white'"
                        >mdi-menu-right</v-icon
                    >
                </a>
            </template>

            <div class="d-flex align-center">
                <v-menu
                    offset-y
                    :nudge-top="0"
                    open-on-hover
                    :close-on-content-click="true"
                    tile
                    z-index="1000000"
                    v-if="!VUETIFY_BREAKPOINT.mobile && showLanguageSwitch"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on" small class="ml-1">
                            <v-icon>mdi-translate</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item @click="changeLanguage('en')">
                            <v-list-item-icon>
                                <v-icon v-if="currentLocale === 'en'" small
                                    >mdi-check</v-icon
                                >
                            </v-list-item-icon>
                            <v-list-item-title>English</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="changeLanguage('zh')">
                            <v-list-item-icon>
                                <v-icon v-if="currentLocale === 'zh'" small
                                    >mdi-check</v-icon
                                >
                            </v-list-item-icon>
                            <v-list-item-title>中文</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-tooltip
                    left
                    v-if="!VUETIFY_BREAKPOINT.mobile && enableAlertMessage"
                >
                    <template
                        v-slot:activator="{
                            on: tooltipOn,
                            attrs: tooltipAttrs,
                        }"
                    >
                        <v-menu bottom offset-y @input="onRecheckIconClicked">
                            <template
                                v-slot:activator="{
                                    on: menuOn,
                                    attrs: menuAttrs,
                                }"
                            >
                                <v-btn
                                    icon
                                    small
                                    color="orange"
                                    dark
                                    class="mr-0"
                                    v-bind="{
                                        ...tooltipAttrs,
                                        ...menuAttrs,
                                    }"
                                    v-on="{ ...tooltipOn, ...menuOn }"
                                    :loading="recheckLoading"
                                    id="recheckIcon"
                                    ref="recheckIcon"
                                >
                                    <v-icon>mdi-progress-check</v-icon>
                                </v-btn>
                            </template>

                            <v-list
                                :style="{
                                    maxHeight: '300px',
                                    overflowY: 'auto',
                                    width: '250px',
                                }"
                            >
                                <v-list-item
                                    v-for="(item, index) in recheckHistoryItems"
                                    :key="index"
                                    style="border-bottom: 1px solid grey"
                                >
                                    <div
                                        style="width: 100%"
                                        @click="
                                            () => getRecheckTaskDetail(item)
                                        "
                                    >
                                        <v-list-item-title
                                            style="
                                                display: flex;
                                                justify-content: space-between;
                                                align-items: center;
                                                font-size: 14px;
                                            "
                                        >
                                            <span style="font-weight: 600">
                                                {{ item.type }}
                                            </span>
                                            <span style="color: grey">
                                                {{
                                                    toMT4Time(
                                                        item.created_at
                                                    ).split(" ")[1]
                                                }}
                                            </span>
                                        </v-list-item-title>
                                        <v-list-item-subtitle
                                            ><v-chip
                                                color="green"
                                                :color="
                                                    item.status === 'PENDING'
                                                        ? 'primary'
                                                        : item.status ===
                                                          'SUCCESS'
                                                        ? 'green'
                                                        : 'red'
                                                "
                                                x-small
                                            >
                                                {{ item.status }}
                                            </v-chip></v-list-item-subtitle
                                        >
                                    </div>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>

                    <span>Click to Show Previous Recheck Tasks</span>
                </v-tooltip>

                <v-tooltip
                    bottom
                    v-if="!VUETIFY_BREAKPOINT.mobile && enableAlertMessage"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            dark
                            v-bind="attrs"
                            v-on="on"
                            color="yellow"
                            class="mr-0"
                            :loading="historyLoading"
                            icon
                            small
                            @click="historyLoading = true"
                        >
                            <v-icon>mdi-message-text-clock</v-icon>
                        </v-btn>
                    </template>
                    <span>Click to Show Alert Message History</span>
                </v-tooltip>
                <v-tooltip
                    bottom
                    v-if="!VUETIFY_BREAKPOINT.mobile && enableAlertMessage"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            dark
                            v-bind="attrs"
                            v-on="on"
                            color="primary"
                            class="mr-0"
                            @click="showMessageProfileDialog = true"
                            :disabled="!configReady"
                            >mdi-message-cog</v-icon
                        >
                    </template>
                    <span
                        >Click to update the Alert Message filter setting</span
                    >
                </v-tooltip>
                <v-tooltip
                    bottom
                    content-class="pumpingStatusTooltip"
                    color="rgba(97, 97, 97, 1)"
                    v-if="!VUETIFY_BREAKPOINT.mobile"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            dark
                            v-bind="attrs"
                            v-on="on"
                            :color="
                                pumpingStatus === 'success'
                                    ? 'green'
                                    : pumpingStatus === 'fail'
                                    ? 'red'
                                    : 'orange'
                            "
                            class="mr-0"
                            >mdi-list-status</v-icon
                        >
                    </template>
                    <table>
                        <tr v-for="i in rowNumber">
                            <td
                                v-for="j in Math.ceil(
                                    pumpingStatusList.length / rowNumber
                                )"
                            >
                                <div
                                    v-if="
                                        isValidServerItem(
                                            pumpingStatusList[
                                                i - 1 + (j - 1) * rowNumber
                                            ]
                                        )
                                    "
                                >
                                    <v-icon
                                        x-small
                                        :color="
                                            pumpingStatusList[
                                                i - 1 + (j - 1) * rowNumber
                                            ].alive
                                                ? 'green'
                                                : 'red'
                                        "
                                        class="pr-1"
                                        >mdi-circle</v-icon
                                    >
                                    <span
                                        >{{
                                            pumpingStatusList[
                                                i - 1 + (j - 1) * rowNumber
                                            ].server
                                        }}
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </table>
                </v-tooltip>
                <!-- <v-tooltip bottom v-if="!VUETIFY_BREAKPOINT.mobile">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                dark
                                v-bind="attrs"
                                v-on="on"
                                color="orange"
                                class="mr-2"
                                @click="holidayDialog = true"
                                >mdi-calendar-weekend</v-icon
                            >
                        </template>
                        <span>Click to see holiday information</span>
                    </v-tooltip> -->
                <v-menu
                    offset-y
                    :nudge-top="0"
                    open-on-hover
                    :close-on-content-click="false"
                    tile
                    z-index="1000000"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <a
                            v-bind="attrs"
                            v-on="on"
                            style="
                                color: white;
                                min-width: 80px;
                                white-space: nowrap;
                            "
                            class="ml-1"
                        >
                            Hi, {{ displayName }}
                        </a>
                    </template>
                    <v-list
                        class="pl-0 pr-0 pt-0 pb-0"
                        style="text-align: left; border-radius: 0px"
                    >
                        <template v-if="!VUETIFY_BREAKPOINT.mobile">
                            <v-list-item
                                dense
                                to="/account/permission"
                                v-if="loadPermission == 1"
                            >
                                <v-list-item-icon class="mr-0"
                                    ><v-icon small
                                        >mdi-shield</v-icon
                                    ></v-list-item-icon
                                >
                                <v-list-item-title>{{
                                    $t("common.table.permission")
                                }}</v-list-item-title>
                            </v-list-item>

                            <v-list-item
                                dense
                                to="/account/management"
                                v-if="loadManagement == 1"
                            >
                                <v-list-item-icon class="mr-0"
                                    ><v-icon small
                                        >mdi-folder-multiple</v-icon
                                    ></v-list-item-icon
                                >
                                <v-list-item-title>{{
                                    $t("common.account.management")
                                }}</v-list-item-title>
                            </v-list-item>

                            <v-list-item
                                dense
                                to="/system/settings"
                                v-if="loadSettings == 1"
                            >
                                <v-list-item-icon class="mr-0"
                                    ><v-icon small
                                        >mdi-cog-outline</v-icon
                                    ></v-list-item-icon
                                >
                                <v-list-item-title>{{
                                    $t("common.account.settings")
                                }}</v-list-item-title>
                            </v-list-item>

                            <v-list-item
                                dense
                                to="/account/security"
                                v-if="loadSecurity == 1"
                            >
                                <v-list-item-icon class="mr-0"
                                    ><v-icon small
                                        >mdi-shield-account</v-icon
                                    ></v-list-item-icon
                                >
                                <v-list-item-title>{{
                                    $t("common.account.security")
                                }}</v-list-item-title>
                            </v-list-item>

                            <v-divider></v-divider>
                        </template>

                        <v-list-item dense @click.stop="logout()">
                            <v-list-item-icon class="mr-0"
                                ><v-icon small
                                    >mdi-logout</v-icon
                                ></v-list-item-icon
                            >
                            <v-list-item-title
                                ><v-btn
                                    text
                                    :loading="logoutLoading"
                                    @click.prevent
                                    class="pl-0 pr-0"
                                    >Logout</v-btn
                                ></v-list-item-title
                            >
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>
        </v-app-bar>

        <v-navigation-drawer
            v-if="VUETIFY_BREAKPOINT.mobile"
            v-model="drawer"
            app
            temporary
            style="top: 40px; height: calc(100% - 40px)"
        >
            <v-list nav dense>
                <v-list-item-group
                    v-model="group"
                    active-class="text--accent-4"
                >
                    <v-list-item
                        v-for="item in drawerRouteList"
                        :key="item.label"
                        :to="item.path"
                    >
                        <v-list-item-title>{{ item.label }}</v-list-item-title>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>

        <v-main>
            <v-container fluid id="global-container">
                <HeaderMenu />

                <router-view></router-view>

                <div class="text-center">
                    <v-overlay :value="this.$store.state.overlay">
                        <v-progress-circular
                            indeterminate
                            :size="70"
                            :width="7"
                            color="primary"
                        ></v-progress-circular>
                        <p>Loading Data...</p>
                    </v-overlay>
                </div>
            </v-container>
            <v-dialog
                v-model="holidayDialog"
                width="1000"
                :persistent="true"
                style="overflow: hidden"
            >
                <v-card class="pt-0">
                    <v-app-bar
                        flat
                        color="rgba(0, 0, 0, 0)"
                        style="background: rgb(26, 57, 88)"
                    >
                        <v-toolbar-title class="text-h6 white--text pl-0">
                            Holiday Information
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="white"
                            icon
                            @click="holidayDialog = false"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-app-bar>

                    <v-card-actions>
                        <v-row>
                            <v-col cols="1"
                                ><div
                                    style="
                                        display: flex;
                                        align-items: end;
                                        justify-content: center;
                                        height: 100%;
                                    "
                                >
                                    Server:
                                </div></v-col
                            ><v-col cols="3">
                                <v-autocomplete
                                    single-line
                                    v-model="selectedServer"
                                    :items="serverOptions"
                                    item-text="server_name"
                                    item-value="id"
                                    clearable
                                    hide-details
                                >
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="1"
                                ><div
                                    style="
                                        display: flex;
                                        align-items: end;
                                        justify-content: center;
                                        height: 100%;
                                    "
                                >
                                    Symbol:
                                </div></v-col
                            ><v-col cols="3">
                                <v-autocomplete
                                    single-line
                                    v-model="selectedSymbol"
                                    :items="symbolOptions"
                                    clearable
                                    hide-details
                                >
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="2"
                                ><div
                                    style="
                                        display: flex;
                                        align-items: end;
                                        justify-content: center;
                                        height: 100%;
                                    "
                                >
                                    Show History:
                                </div></v-col
                            >
                            <v-col cols="2"
                                ><v-switch
                                    style="margin-top: 4px"
                                    v-model="showHistory"
                                    dense
                                    hide-details
                                ></v-switch
                            ></v-col>
                            <v-col cols="1"
                                ><div
                                    style="
                                        display: flex;
                                        align-items: end;
                                        justify-content: center;
                                        height: 100%;
                                    "
                                >
                                    Year:
                                </div></v-col
                            ><v-col cols="3">
                                <v-autocomplete
                                    single-line
                                    v-model="selectedYear"
                                    :items="yearOptions"
                                    clearable
                                    hide-details
                                >
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="1"
                                ><div
                                    style="
                                        display: flex;
                                        align-items: end;
                                        justify-content: center;
                                        height: 100%;
                                    "
                                >
                                    Month:
                                </div></v-col
                            ><v-col cols="3">
                                <v-autocomplete
                                    single-line
                                    v-model="selectedMonth"
                                    :items="MonthOptions"
                                    item-text="text"
                                    item-value="value"
                                    clearable
                                    hide-details
                                >
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="1"
                                ><div
                                    style="
                                        display: flex;
                                        align-items: end;
                                        justify-content: center;
                                        height: 100%;
                                    "
                                >
                                    Day:
                                </div></v-col
                            ><v-col cols="3">
                                <v-autocomplete
                                    single-line
                                    v-model="selectedDay"
                                    :items="dayOptions"
                                    clearable
                                    hide-details
                                >
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12"
                                ><v-data-table
                                    dense
                                    :headers="holidayTableHeader"
                                    :items="holidayTableData"
                                    :header-props="{ sortIcon: null }"
                                    item-key="id"
                                    class="elevation-0 flex-grow-1"
                                    :items-per-page="25"
                                    id="home-table"
                                    fixed-header
                                >
                                    <template
                                        v-slot:item.server_id="{ item }"
                                        >{{
                                            serverOptions.find(
                                                (data) =>
                                                    data.id === item.server_id
                                            ).server_name
                                        }}</template
                                    >
                                    <template
                                        v-slot:item.description="{ item }"
                                    >
                                        <div
                                            v-if="item.description.length < 53"
                                        >
                                            {{ item.description }}
                                        </div>
                                        <v-tooltip top v-else>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <div v-bind="attrs" v-on="on">
                                                    {{
                                                        item.description.slice(
                                                            0,
                                                            53
                                                        )
                                                    }}...
                                                </div>
                                            </template>
                                            <span>{{ item.description }}</span>
                                        </v-tooltip>
                                    </template>
                                </v-data-table></v-col
                            >
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-main>

        <div style="position: fixed; bottom: 20px; right: 20px; z-index: 6">
            <div v-for="(snackbar, index) in snackBars" :key="index">
                <v-snackbar
                    :vertical="true"
                    v-model="snackbar.type"
                    timeout="-1"
                    right
                    bottom
                    :ref="'snackbar-' + snackbar.id"
                    :style="{
                        marginBottom: `${snackbar.offset}px`,
                        color: 'black',
                    }"
                    width="300"
                    :color="messageColorMapping[snackbar.type]"
                    content-class="customizedSnackbar"
                >
                    <div
                        style="
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            font-weight: 700;
                            font-size: 18px;
                        "
                    >
                        <div style="margin-left: -2px">
                            {{ computedType(snackbar.type) }}
                        </div>
                        <div
                            style="
                                display: flex;
                                flex-wrap: wrap;
                                margin-right: -10px;
                                margin-top: -5px;
                            "
                        >
                            <v-tooltip left>
                                <template
                                    v-slot:activator="{
                                        on: tooltipOn,
                                        attrs: tooltipAttrs,
                                    }"
                                >
                                    <v-menu offset-y top>
                                        <template
                                            v-slot:activator="{
                                                on: menuOn,
                                                attrs: menuAttrs,
                                            }"
                                            ><v-icon
                                                dark
                                                v-bind="{
                                                    ...tooltipAttrs,
                                                    ...menuAttrs,
                                                }"
                                                v-on="{
                                                    ...tooltipOn,
                                                    ...menuOn,
                                                }"
                                                class="snackbar-icon"
                                                color="orange"
                                                >mdi-bell-off</v-icon
                                            >
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                v-for="(
                                                    item, index
                                                ) in muteOptions"
                                                :key="index"
                                            >
                                                <v-list-item-title
                                                    @click="
                                                        muteType(
                                                            snackbar.type,
                                                            item.title
                                                        )
                                                    "
                                                    >{{
                                                        item.title
                                                    }}</v-list-item-title
                                                >
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </template>
                                <span
                                    >Mute this alert temporarily for a selected
                                    duration.</span
                                >
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        class="snackbar-icon"
                                        v-bind="attrs"
                                        v-on="on"
                                        color="green"
                                        @click="openSnackbar(snackbar)"
                                    >
                                        mdi-eye
                                    </v-icon>
                                </template>
                                <span>View Alert Message</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        class="snackbar-icon"
                                        v-bind="attrs"
                                        v-on="on"
                                        color="red"
                                        @click="removeSnackbar(snackbar)"
                                    >
                                        mdi-close
                                    </v-icon>
                                </template>
                                <span>Close Alert Message</span>
                            </v-tooltip>
                        </div>
                    </div>
                    <div>{{ snackbar.title }}</div>
                </v-snackbar>
            </div>
        </div>
        <v-dialog
            ref="msgDialog"
            v-model="showModal"
            :width="1000"
            :hide-overlay="true"
            :persistent="true"
        >
            <v-card id="messageModal">
                <v-app-bar
                    flat
                    color="rgba(0, 0, 0, 0)"
                    style="background: rgb(26, 57, 88)"
                >
                    <v-toolbar-title class="text-h6 white--text pl-0">
                        {{ computedType(modalData.type) }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon color="red" icon @click="showModal = false">
                        mdi-close
                    </v-icon>
                </v-app-bar>

                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <div style="font-size: 18px; font-weight: 700">
                                {{ modalData.title }}
                            </div>
                        </v-col>
                        <v-col
                            cols="12"
                            style="max-height: 60vh; overflow-y: scroll"
                        >
                            <pre
                                v-if="!!modalData.body"
                                style="
                                    white-space: pre-wrap;
                                    word-break: break-word;
                                "
                                >{{ modalData.body }}</pre
                            >
                            <div class="modal-body" v-if="!!modalData.html">
                                <div
                                    class="html-content"
                                    v-html="modalData.html"
                                ></div>
                            </div>
                            <IntradayRiskyAccountDetails
                                :modalData="modalData"
                                :isOpen="showModal"
                                v-if="
                                    modalData.type === 'Intraday Risky Account'
                                "
                            />
                        </v-col>

                        <v-col
                            cols="12"
                            style="display: flex; justify-content: center"
                        >
                            <span v-if="!!modalData.login">
                                <v-btn
                                    v-if="modalData.in_watchlist"
                                    color="orange darken-2"
                                    class="pa-2 mr-2"
                                    @click="
                                        redirectTo(
                                            'edit',
                                            modalData.login?.split('-')[1]
                                        )
                                    "
                                    >Edit Watchlist
                                </v-btn>
                                <v-btn
                                    v-else
                                    color="green darken-2"
                                    class="pa-2 mr-2"
                                    @click="
                                        redirectTo(
                                            'add',
                                            modalData.login?.split('-')[1],
                                            modalData.login?.split('-')[0]
                                        )
                                    "
                                    >Add to Watchlist
                                </v-btn>
                                <v-btn
                                    color="blue darken-2"
                                    class="pa-2 mr-2"
                                    @click="
                                        redirectTo(
                                            'info',
                                            modalData.login?.split('-')[1],
                                            modalData.login?.split('-')[0]
                                        )
                                    "
                                    >Jump To Login Detail
                                </v-btn>
                            </span>
                            <span
                                v-if="
                                    !!modalData.feature &&
                                    modalData.feature.includes('recheck')
                                "
                            >
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            color="teal darken-1"
                                            v-bind="attrs"
                                            v-on="on"
                                            id="recheckButton"
                                            @click="startRecheck()"
                                            class="pa-2 mr-2"
                                        >
                                            Re-check
                                        </v-btn>
                                    </template>
                                    <span
                                        >Click to initiate re-check
                                        process.</span
                                    >
                                </v-tooltip>
                            </span>
                        </v-col>
                        <v-col
                            cols="12"
                            style="
                                display: flex;
                                justify-content: center;
                                padding-top: 0;
                            "
                        >
                            <v-tooltip
                                top
                                v-if="
                                    modalData.risk_rating >= 0 &&
                                    isRiskRatingAllowed
                                "
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        color="grey darken-1"
                                        class="pa-2 mr-2"
                                        @click="openRatingModal('risk')"
                                        >Risk Rating

                                        <v-icon class="ml-0" right dark>
                                            {{
                                                modalData.risk_rating > 0
                                                    ? "mdi-star"
                                                    : "mdi-star-outline"
                                            }}
                                        </v-icon>
                                    </v-btn> </template
                                ><span>{{
                                    modalData.risk_rating > 0
                                        ? "Rated"
                                        : "Unrated"
                                }}</span>
                            </v-tooltip>
                            <v-tooltip
                                top
                                v-if="
                                    modalData.time_decay_rating >= 0 &&
                                    isRiskRatingAllowed &&
                                    modalData.toxic_time_decay > 0
                                "
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        color="grey darken-1"
                                        class="pa-2 mr-2"
                                        @click="openRatingModal('time_decay')"
                                        v-bind="attrs"
                                        v-on="on"
                                        >Time Decay Rating

                                        <v-icon class="ml-0" right dark>
                                            {{
                                                modalData.time_decay_rating > 0
                                                    ? "mdi-star"
                                                    : "mdi-star-outline"
                                            }}
                                        </v-icon>
                                    </v-btn></template
                                ><span>{{
                                    modalData.time_decay_rating > 0
                                        ? "Rated"
                                        : "Unrated"
                                }}</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="showMessageProfileDialog"
            width="700"
            :persistent="true"
        >
            <v-card :loading="messageConfigLoading">
                <v-app-bar
                    flat
                    color="rgba(0, 0, 0, 0)"
                    style="background: rgb(26, 57, 88)"
                >
                    <v-toolbar-title class="text-h6 white--text pl-0"
                        >Alert Message Filter Config</v-toolbar-title
                    >
                </v-app-bar>
                <div class="pa-2 pl-4" :style="{ fontSize: '16px' }">
                    Toggle settings below to customize allowed alert message
                    type and sound settings.
                </div>

                <v-card-text style="padding-top: 0px; padding-bottom: 0">
                    <v-row
                        v-for="key in Object.keys(messageConfigModal['sub'])"
                        :key="key"
                        style="padding: 0px 0px"
                    >
                        <v-col cols="6">
                            <h3>{{ messageTypeLabelMapping[key] }}</h3>
                        </v-col>
                        <v-col cols="3">
                            <v-checkbox
                                v-model="messageConfigModal['sub'][key]"
                                hide-details
                                style="margin: 0; padding: 0"
                            >
                                <template v-slot:label> Subscribe </template>
                            </v-checkbox>
                        </v-col>
                        <v-col cols="3">
                            <v-checkbox
                                v-model="messageConfigModal['sound'][key]"
                                hide-details
                                style="margin: 0; padding: 0"
                            >
                                <template v-slot:label> Sound </template>
                            </v-checkbox>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red"
                        :disabled="messageConfigLoading"
                        @click="showMessageProfileDialog = false"
                        text
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        color="green"
                        text
                        :loading="messageConfigLoading"
                        @click="updateAlertMessageConfig"
                    >
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-overlay :value="overlay" v-if="enableAlertMessage">
            <div v-if="overlayLoading">
                <v-progress-circular
                    indeterminate
                    :size="70"
                    :width="7"
                    color="primary"
                ></v-progress-circular>
                <p>Loading...</p>
            </div>
            <div v-else>
                <v-card width="500">
                    <v-app-bar
                        flat
                        color="rgba(0, 0, 0, 0)"
                        style="background: rgb(26, 57, 88)"
                    >
                        <v-toolbar-title class="text-h6 white--text pl-0"
                            >Site Sound Activation</v-toolbar-title
                        >
                    </v-app-bar>

                    <v-card-text class="pb-0">
                        <div :style="{ fontSize: '18px' }">
                            <div class="pa-2">
                                New alert messages will trigger sound effect.
                            </div>
                            <div class="pa-2">
                                To disable, unselect all sound settings listed
                                in
                                <v-icon color="primary">mdi-message-cog</v-icon>
                            </div>
                        </div>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green" text @click="overlay = false">
                            Ok
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </div>
        </v-overlay>
        <RatingModal
            :isOpen="isRatingModalOpen"
            :type="ratingModalType"
            :modalData="modalData"
            @close="closeModal"
        />
        <v-navigation-drawer
            v-model="showAlertMessagePool"
            fixed
            temporary
            right
            width="300"
            style="height: calc(100vh - 40px); top: 40px"
        >
            <div style="position: sticky; top: 0; z-index: 1">
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title
                            style="
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                            "
                        >
                            <b>Notification History</b>
                            <div>
                                <v-menu offset-y bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            color="orange"
                                            icon
                                            v-bind="attrs"
                                            v-on="on"
                                            small
                                        >
                                            <v-icon dark>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item
                                            v-for="(
                                                item, index
                                            ) in alertMessageHistoryFilter"
                                            :key="index"
                                            @click="messageFilter = item"
                                        >
                                            <v-list-item-title>{{
                                                computedType(item)
                                            }}</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item
                                            key="removeFilter"
                                            :disabled="!messageFilter"
                                            :style="
                                                messageFilter
                                                    ? { color: 'lime' }
                                                    : {}
                                            "
                                            @click="messageFilter = undefined"
                                        >
                                            <v-list-item-title>
                                                Remove Filter
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                                <v-btn
                                    color="green"
                                    icon
                                    @click="historyLoading = true"
                                    :loading="historyLoading"
                                    small
                                >
                                    <v-icon>mdi-refresh</v-icon>
                                </v-btn>
                            </div>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
            </div>

            <div style="max-height: calc(100vh - 90px); overflow-y: auto">
                <v-list dense>
                    <v-list-item
                        v-for="item in computedMessagePool"
                        :key="item.date"
                        style="border-bottom: 1px solid grey"
                    >
                        <v-list-item-content @click="openSnackbar(item)">
                            <v-list-item-title
                                style="
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                "
                            >
                                <div>
                                    <v-icon
                                        class="mb-1"
                                        :color="messageColorMapping[item.type]"
                                        >mdi-circle-medium</v-icon
                                    ><span
                                        style="font-weight: bold"
                                        v-html="computedType(item.type)"
                                    ></span>
                                </div>
                                <div v-html="item.time.split(' ')[1]"></div>
                            </v-list-item-title>

                            <v-list-item-subtitle
                                v-html="item.title"
                                style="white-space: normal; padding-left: 8px"
                            />
                            <v-list-item-subtitle
                                v-if="
                                    item.type === 'Intraday Risky Account' &&
                                    isRiskRatingAllowed
                                "
                                style="white-space: normal; padding-left: 8px"
                            >
                                <div v-if="item.updated_at">
                                    <v-tooltip top v-if="isRiskRatingAllowed">
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <span v-bind="attrs" v-on="on">
                                                <v-chip
                                                    color="green"
                                                    x-small
                                                    class="mb-1"
                                                    >Rated</v-chip
                                                >
                                                -
                                                {{ item.updated_at }}
                                            </span></template
                                        ><span>
                                            <div>
                                                - Risk Rating:
                                                {{ item.risk_rating }} stars
                                            </div>
                                            <div>
                                                - Time Decay Rating:
                                                {{ item.time_decay_rating }}
                                                stars
                                            </div>
                                            <div>
                                                - Rated by:
                                                <span style="font-weight: 600">
                                                    {{ item.username }}
                                                </span>
                                            </div>
                                        </span>
                                    </v-tooltip>
                                </div>
                                <div v-else>
                                    <v-chip color="orange" x-small
                                        >Unrated</v-chip
                                    >
                                </div>
                            </v-list-item-subtitle>
                            <v-list-item-subtitle
                                v-if="item.is_recheck"
                                style="white-space: normal; padding-left: 8px"
                                ><v-chip color="primary" x-small
                                    >re-check</v-chip
                                ></v-list-item-subtitle
                            >
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </div>
        </v-navigation-drawer>
    </div>
</template>

<script>
// import { List } from "immutable";
import HeaderMenu from "@components/HeaderMenu";
import RatingModal from "@components/RatingModal";
import CurrentLiveTime from "@components/ComponentCurrentLiveTime";
import IntradayRiskyAccountDetails from "@components/IntradayRiskyAccountDetails";
import { permission } from "@components/mixins/permission";
import { putUsers } from "@services/account/user";
import { logUserOut } from "@services/account/auth";
import { getAlertMessageHistory } from "@services/alert-message";
import {
    getPageProfile,
    postPageProfile,
    putPageProfile,
} from "@services/page-profile";
import {
    recheckTask,
    recheckTaskStatus,
    fetchRecheckTaskResult,
} from "@services/functional-api";
// import { getHolidayData } from "@services/holiday";
import dayjs from "dayjs";
import deepClone from "deep-clone";
import { mapState, mapActions } from "vuex";
import { getPumpingStatus } from "@services/pumping-status";
import { snackbar } from "@components/mixins/snackbar";
import { playNotificationSound, unlockAudio } from "@assets/soundPlayer";
import { helper } from "@components/mixins/helper";
import { redirectToRH } from "@utils/util";

var isoWeek = require("dayjs/plugin/isoWeek");
dayjs.extend(isoWeek);

let utc = require("dayjs/plugin/utc");
let timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);
export default {
    name: "Layout",
    components: {
        CurrentLiveTime,
        HeaderMenu,
        RatingModal,
        IntradayRiskyAccountDetails,
    },
    mixins: [permission, snackbar, helper],
    data: () => ({
        recheckHistoryItems: [],
        muteOptionTypes: [
            "enableMarginAlertMessage",
            "enablePositionRecMessage",
            "enablePositionPNLMessage",
            "enableIntradayRiskyAccount",
            "enableLargeVolumeAlert",
            "enableMarketNewsMessage",
            "enableHourlyUpdatesMessage",
        ],
        messageTypeLabelMapping: {
            enableMarginAlertMessage: "Margin Alert",
            enablePositionPNLMessage: "Position PNL Alert",
            enableIntradayRiskyAccount: "Intraday Risky Account",
            enableLargeVolumeAlert: "Large Volume Alert",
            enableMarketNewsMessage: "Market News Alert",
            enableHourlyUpdatesMessage: "Hourly Updates",
            enablePositionRecMessage: "Position Rec Alert",
        },
        messageTypeBindings: {
            enableMarginAlertMessage: ["Margin Alert"],
            enablePositionPNLMessage: [
                "Position Total Alert",
                "Position Change Alert",
                "PNL Total Alert",
                "PNL Change Alert",
            ],
            enablePositionRecMessage: ["Position Rec Alert"],
            enableIntradayRiskyAccount: ["Intraday Risky Account"],
            enableLargeVolumeAlert: ["Large Volume Alert"],
            enableMarketNewsMessage: ["Market News Alert"],
            enableHourlyUpdatesMessage: ["Hourly Updates"],
        },
        specifiedDifferentMessageSoundTypes: [
            "Margin Alert",
            "Position Total Alert",
            "Position Change Alert",
            "PNL Total Alert",
            "PNL Change Alert",
            "Position Rec Alert",
        ],
        pumpingStatus: "success",
        pumpingStatusTimer: null,
        pumpingStatusList: [],

        loadManagement: 0,
        loadSecurity: 0,
        loadSettings: 0,
        loadPermission: 0,
        recheckLoading: false,

        alertDrawer: false,
        channelList: [],
        selectedAlertPanel: 1,
        loadRing: true,
        profileUpdate: {
            home: false,
            alert: false,
        },
        logoutLoading: false,

        holidayDialog: false,
        holidayTableHeader: [
            { text: "Server", value: "server_id", width: 30, align: "left" },
            { text: "Symbol", value: "symbol", width: 60, align: "left" },
            { text: "Date", value: "date", width: 90, align: "left" },
            {
                text: "Description",
                value: "description",
                width: 200,
                align: "left",
            },
        ],
        holidayData: [],
        dayOfWeek: {
            1: "Monday",
            2: "Tuesday",
            3: "Wednesday",
            4: "Thursday",
            5: "Friday",
            6: "Saturday",
            7: "Sunday",
        },
        serverOptions: [],
        symbolOptions: [],
        yearOptions: [],
        MonthOptions: [
            { text: "January", value: 1 },
            { text: "February", value: 2 },
            { text: "March", value: 3 },
            { text: "April", value: 4 },
            { text: "May", value: 5 },
            { text: "June", value: 6 },
            { text: "July", value: 7 },
            { text: "August", value: 8 },
            { text: "September", value: 9 },
            { text: "October", value: 10 },
            { text: "November", value: 11 },
            { text: "December", value: 12 },
        ],
        dayOptions: [
            1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
            20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
        ],
        selectedServer: null,
        selectedSymbol: null,
        selectedYear: null,
        selectedMonth: null,
        selectedDay: null,
        showHistory: false,
        screenWidth: 0,
        menuWidth: 0,
        showMenuButton: false,
        disableToMoveLeft: false,
        disableToMoveRight: true,
        drawer: false,
        group: 0,
        drawerRouteList: [
            {
                path: "/",
                label: "Home",
            },
        ],
        eventSource: null,
        snackBars: [],
        showModal: false,
        modalData: {
            type: "",
            title: "",
            body: "",
            html: "",
            login: "",
            in_watchlist: undefined,
        },
        enableAlertMessage: false,
        showMessageProfileDialog: false,
        permissionMessageTypes: [],
        allowedMessageTypes: [],
        allowedSoundTypes: [],
        messageConfigLoading: false,
        messageConfigModal: { sub: {}, sound: {} },
        profileId: undefined,
        showMuteTooltip: false,
        muteOptions: [
            { title: "10 min" },
            { title: "30 min" },
            { title: "1 hour" },
            { title: "4 hour" },
            { title: "Today" },
        ],
        configReady: false,
        overlay: true,
        overlayLoading: true,
        showAlertMessagePool: false,
        alertMessagePool: [],
        historyLoading: false,
        messageColorMapping: {
            "Margin Alert": "#FA8072",
            "Position Total Alert": "#e9c46a",
            "Position Change Alert": "#e9c46a",
            "PNL Total Alert": "#e9c46a",
            "PNL Change Alert": "#e9c46a",
            "Intraday Risky Account": "#90BE6D",
            "Market News Alert": "#2a9d8f",
            "Hourly Updates": "#f4a261",
            "Position Rec Alert": "#e76f51",
            "Large Volume Alert": "#8ecae6",
            "": "#7678ed",
        },
        messageFilter: undefined,
        isRatingModalOpen: false,
        ratingModalType: "",
        isRiskRatingAllowed: false,
        recheckInterval: null,
        showLanguageSwitch: false,
        currentLocale: localStorage.getItem("locale") || "en",
    }),
    computed: {
        ...mapState("SettingsServer", ["serverData"]),
        ...mapState(["showMsgDialog", "msgDialogData"]),
        pkTitle() {
            return this.VUETIFY_BREAKPOINT.mobile ? "PK" : "Position Keeper";
        },
        rowNumber() {
            const maxRowNumber = 25;
            if (this.pumpingStatusList.length > maxRowNumber) {
                const colNumber = Math.ceil(
                    this.pumpingStatusList.length / maxRowNumber
                );
                return Math.ceil(this.pumpingStatusList.length / colNumber);
            } else {
                return this.pumpingStatusList.length;
            }
        },
        displayName() {
            return localStorage.getItem("displayName");
        },
        holidayTableData() {
            let returnValue = deepClone(this.holidayData);
            if (this.selectedServer) {
                returnValue = returnValue.filter(
                    (item) => item.server_id === this.selectedServer
                );
            }
            if (this.selectedSymbol) {
                returnValue = returnValue.filter(
                    (item) => item.symbol === this.selectedSymbol
                );
            }
            if (this.selectedYear) {
                returnValue = returnValue.filter(
                    (item) => item.year === this.selectedYear
                );
            }
            if (this.selectedMonth) {
                returnValue = returnValue.filter(
                    (item) => item.month === this.selectedMonth
                );
            }
            if (this.selectedDay) {
                returnValue = returnValue.filter(
                    (item) => item.day === this.selectedDay
                );
            }
            if (!this.showHistory) {
                const today = dayjs(dayjs().format("YYYY-MM-DD")).unix();
                returnValue = returnValue.filter(
                    (item) =>
                        dayjs(
                            item.year + "-" + item.month + "-" + item.day
                        ).unix() >= today
                );
            }
            return returnValue;
        },
        alertMessageHistoryFilter() {
            return this.permissionMessageTypes.flatMap(
                (i) => this.messageTypeBindings[i] || []
            );
        },
        userLevelAllowedTypes() {
            const set2 = new Set(this.permissionMessageTypes);
            const intersectionMessage = this.allowedMessageTypes.filter(
                (item) => set2.has(item)
            );

            return intersectionMessage.flatMap(
                (i) => this.messageTypeBindings[i]
            );
        },
        userLevelAllowedSoundTypes() {
            const set2 = new Set(this.permissionMessageTypes);
            const intersectionSound = this.allowedSoundTypes.filter((item) =>
                set2.has(item)
            );

            return intersectionSound.flatMap(
                (i) => this.messageTypeBindings[i]
            );
        },
        computedMessagePool() {
            const result = this.messageFilter
                ? this.alertMessagePool.filter(
                      (message) => message.type === this.messageFilter
                  )
                : this.alertMessagePool;
            return result;
        },
    },
    watch: {
        allowedMessageTypes(nv) {
            if (nv) {
                nv.map((item) => {
                    if (this.permissionMessageTypes.includes(item)) {
                        this.messageConfigModal["sub"][item] = true;
                    }
                });
            }
        },
        allowedSoundTypes(nv) {
            if (nv) {
                nv.map((item) => {
                    if (this.permissionMessageTypes.includes(item)) {
                        this.messageConfigModal["sound"][item] = true;
                    }
                });

                this.overlayLoading = false;
                if (!nv.length) {
                    this.overlay = false;
                }
            }
        },
        profileUpdate(nv) {
            if (nv.alert && nv.home) {
                this.$router.push({ name: "Signin" });
                this.$store.state.loginStatus = -1;
                logUserOut({ id: 0 }).then(() => {
                    const saved = localStorage.getItem("locale") || "en";
                    localStorage.clear();
                    localStorage.setItem("locale", saved);
                });
            }
        },
        serverData(nv) {
            this.serverOptions = nv;
        },
        snackBars(nv) {
            this.calculateOffsets(nv);
        },
        historyLoading(nv) {
            if (nv) {
                this.getAlertMessageHistoryFromApi();
            }
        },
        recheckHistoryItems(nv, ov) {
            if (
                JSON.stringify(nv) !== JSON.stringify(ov) &&
                this.enableAlertMessage
            ) {
                this.shakeIcon();
            }
        },
        showMsgDialog(val) {
            if (val && this.msgDialogData) {
                this.modalData = deepClone(this.msgDialogData);
                this.showModal = true;
                this.$store.commit("CLOSE_MSG_DIALOG");
            }
        },
    },
    methods: {
        ...mapActions("SettingsServer", [
            "getServerAction",
            "getLotDigitsAction",
        ]),
        ...mapActions("Home", ["getLotDigitsAction"]),
        changeLanguage(lang) {
            this.currentLocale = lang;
            this.$i18n.locale = lang;
            localStorage.setItem("locale", lang);
            localStorage.removeItem("mainHeader");
            // Force page reload to update all static content
            window.location.reload();
        },
        isValidServerItem(item) {
            if (!!item) return true;
        },
        getRecheckTaskDetail({ id, status }) {
            if (status === "SUCCESS") {
                this.recheckLoading = true;
                fetchRecheckTaskResult({ id })
                    .then(({ data }) => {
                        this.openSnackbar(data);
                    })
                    .finally(() => {
                        this.recheckLoading = false;
                    });
            }
        },
        onRecheckIconClicked(value) {
            if (value) {
                this.fetchRecheckStatus();
            }
        },
        shakeIcon() {
            const el = this.$refs.recheckIcon.$el;

            el.classList.remove("alarm-2s");
            void el.offsetWidth;
            el.classList.add("alarm-2s");
        },
        minimizeModalToIcon(
            modalEl,
            iconEl,
            { duration = 1000, easing = "cubic-bezier(.2,.9,.2,1)" } = {}
        ) {
            if (!modalEl || !iconEl) return Promise.resolve();

            // Force layout read *now* (before Vue hides it)
            const a = modalEl.getBoundingClientRect();
            const b = iconEl.getBoundingClientRect();

            const safeScale = (from, to) =>
                from > 0 ? Math.max(to / from, 0.01) : 0.01;

            const ax = a.left + a.width / 2;
            const ay = a.top + a.height / 2;
            const bx = b.left + b.width / 2;
            const by = b.top + b.height / 2;

            const translateX = bx - ax;
            const translateY = by - ay;

            const endScaleX = safeScale(a.width, b.width);
            const endScaleY = safeScale(a.height, b.height);

            modalEl.style.transformOrigin = "center center";
            modalEl.style.willChange = "transform, opacity, filter";
            modalEl.style.pointerEvents = "none";

            const animation = modalEl.animate(
                [
                    {
                        transform: "translate(0,0) scale(1,1)",
                        opacity: 1,
                        filter: "blur(0px)",
                    },
                    {
                        transform: `translate(${translateX}px, ${translateY}px) scale(${endScaleX}, ${endScaleY})`,
                        opacity: 0.15,
                        filter: "blur(1px)",
                    },
                ],
                { duration, easing, fill: "forwards" }
            );

            return animation.finished.finally(() => {
                if (animation.commitStyles) animation.commitStyles();
                animation.cancel();
            });
        },
        getDialogSurfaceEl() {
            return (
                document.querySelector(".v-dialog.v-dialog--active") ||
                document.querySelector(".v-dialog")
            );
        },
        async startRecheck() {
            const params = {
                type: this.modalData.type,
                recheck_param: this.modalData?.recheck_param,
            };

            try {
                const res = await recheckTask(params);

                if (res?.data?.msg) {
                    this.snackBarSuccess(res.data.msg);

                    const dialogEl = this.getDialogSurfaceEl();
                    const iconEl =
                        this.$refs.recheckIcon?.$el ||
                        document.getElementById("recheckIcon");

                    await this.minimizeModalToIcon(dialogEl, iconEl);

                    this.showModal = false;

                    setTimeout(() => {
                        this.$nextTick(() => {
                            dialogEl.style.transform = "";
                            dialogEl.style.opacity = "";
                            dialogEl.style.filter = "";
                            dialogEl.style.willChange = "";
                            dialogEl.style.pointerEvents = "";
                            dialogEl.style.transformOrigin = "";
                        });
                    }, 200);
                } else {
                    this.snackBarWarning(
                        "Something went wrong. Please try again later."
                    );
                }
            } catch (error) {
                const msg =
                    error?.response?.data?.msg ||
                    error?.message ||
                    "Failed to start re-check task.";
                this.snackBarDanger(msg);
            } finally {
                this.fetchRecheckStatus();
            }
        },
        updateAlertMessageConfig() {
            this.messageConfigLoading = true;
            const paramValue = {
                allowed_message: Object.keys(this.messageConfigModal["sub"])
                    .map((item) => {
                        if (this.messageConfigModal["sub"][item]) {
                            return item;
                        } else {
                            this.messageConfigModal["sub"];
                        }
                    })
                    .filter(Boolean),
                allowed_sound: Object.keys(this.messageConfigModal["sound"])
                    .map((item) => {
                        if (this.messageConfigModal["sound"][item]) {
                            return item;
                        } else {
                            this.messageConfigModal["sound"];
                        }
                    })
                    .filter(Boolean),
            };

            if (this.profileId) {
                const params = {
                    id: this.profileId,
                    profile_name: "default",
                    value: paramValue,
                };

                putPageProfile(params).then((res) => {
                    this.messageConfigLoading = false;
                    this.showMessageProfileDialog = false;
                    this.getProfileReady();
                });
            } else {
                const params = {
                    meta_value: "message",
                    profile_name: "default",
                    value: paramValue,
                };

                postPageProfile(params).then((res) => {
                    this.messageConfigLoading = false;
                    this.showMessageProfileDialog = false;
                    this.getProfileReady();
                });
            }
        },
        logout() {
            this.logoutLoading = true;

            this.profileUpdate = {
                home: true,
                alert: true,
            };
        },
        changeDrawTab(key) {
            this.selectedAlertPanel = key;
        },
        darkMode() {
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
        },
        updateHomeProfile() {
            putUsers({
                meta_value: "home",
                profile_id:
                    localStorage.getItem("homeId") == "null"
                        ? 0
                        : localStorage.getItem("homeId"),
            }).then(() => {
                this.profileUpdate = {
                    home: true,
                    alert: this.profileUpdate.alert,
                };
            });
        },
        updateAlertProfile() {
            putUsers({
                meta_value: "alert",
                profile_id:
                    localStorage.getItem("alertId") == "null"
                        ? 0
                        : localStorage.getItem("alertId"),
            }).then(() => {
                this.profileUpdate = {
                    home: this.profileUpdate.home,
                    alert: true,
                };
            });
        },
        updateWidth() {
            if (window.innerWidth - 32 - 25 - 16 - 140 - 80 - 32 - 48 > 1250) {
                this.showMenuButton = false;
            } else {
                this.showMenuButton = true;

                this.checkMovability();
            }
        },
        onScreenResize() {
            window.addEventListener("resize", () => {
                this.updateWidth();
            });
        },
        moveDiv(direction) {
            let counter = 0;
            const interval = setInterval(() => {
                this.checkMovability();
                if (counter < 100) {
                    document.getElementById("timeDiv").scrollLeft +=
                        5 * direction;
                    counter += 2;
                } else clearInterval(interval);
            }, 1);
        },
        checkMovability() {
            if (document.getElementById("timeDiv")?.scrollLeft === 0) {
                this.disableToMoveLeft = true;
                this.disableToMoveRight = false;
            } else if (
                document.getElementById("timeDiv")?.scrollLeft +
                    document.getElementById("timeDiv")?.clientWidth >
                1430
            ) {
                this.disableToMoveRight = true;
                this.disableToMoveLeft = false;
            } else {
                this.disableToMoveLeft = false;
                this.disableToMoveRight = false;
            }
        },
        checkPumpingStatus() {
            getPumpingStatus().then((res) => {
                res.data.sort((a, b) => {
                    if (a.server.toLowerCase() < b.server.toLowerCase())
                        return -1;
                    if (a.server.toLowerCase() > b.server.toLowerCase())
                        return 1;
                    return 0;
                });
                this.pumpingStatusList = res.data;
                let trueCount = 0;
                res.data.map((item) => {
                    if (item.alive) {
                        trueCount += 1;
                    }
                });
                if (trueCount === res.data.length) {
                    this.pumpingStatus = "success";
                } else if (trueCount === 0) {
                    this.pumpingStatus = "fail";
                } else {
                    this.pumpingStatus = "partial";
                }
            });
        },
        connectSSE() {
            let APIURL =
                document.querySelector("body").getAttribute("apiurl") ||
                // "http://13.210.184.160:5000";
                process.env.VUE_APP_ENDPOINT;

            this.eventSource = new EventSource(
                APIURL +
                    "/api/v1/alert-message?user_id=" +
                    localStorage.getItem("user_id")
            );

            this.eventSource.onmessage = (event) => {
                const data = JSON.parse(event.data);
                const existingMuteUntil = JSON.parse(
                    localStorage.getItem(`muteUntil`)
                );
                const currentTime = dayjs().unix();
                if (
                    existingMuteUntil &&
                    existingMuteUntil?.[data?.type] &&
                    currentTime < existingMuteUntil?.[data?.type]
                ) {
                    console.log(
                        `Muted message of type ${data?.type} until ${dayjs
                            .unix(existingMuteUntil[data?.type])
                            .format("YYYY-MM-DD HH:mm:ss")}`
                    );
                    return;
                }

                if (this.userLevelAllowedTypes.includes(data?.type)) {
                    if (this.snackBars.length > 7) {
                        this.snackBars.shift();
                    }
                    const newSnackBar = {
                        ...data,
                    };

                    this.snackBars.push(newSnackBar);
                    this.alertMessagePool = [
                        {
                            time: dayjs()
                                .tz("US/Eastern")
                                .add(7, "hour")
                                .add(-1, "day")
                                .format("YYYY-MM-DD HH:mm:ss"),
                            ...newSnackBar,
                        },
                        ...this.alertMessagePool,
                    ];
                    setTimeout(() => {
                        this.removeSnackbar(newSnackBar);
                    }, 60000);
                    if (this.userLevelAllowedSoundTypes.includes(data?.type)) {
                        if (
                            this.specifiedDifferentMessageSoundTypes.includes(
                                data?.type
                            )
                        ) {
                            playNotificationSound(true);
                        } else {
                            playNotificationSound();
                        }
                    }
                }

                if (
                    data?.type === "Margin Alert" ||
                    data?.type === "Position Rec Alert" ||
                    data?.type === "Intraday Risky Account"
                ) {
                    this.fetchRecheckStatus();
                }
            };

            this.eventSource.onerror = (error) => {
                console.error("SSE error:", error);
                this.eventSource.close();
                setTimeout(() => {
                    console.log("Reconnecting to SSE...");
                    this.connectSSE();
                }, 3000);
            };
        },
        openSnackbar(snackbar) {
            // console.log(snackbar);
            this.modalData = deepClone(snackbar);
            this.showModal = true;
            this.snackBars = this.snackBars.filter(
                (item) => snackbar.index !== item.index
            );
        },
        removeSnackbar(snackbar) {
            this.snackBars = this.snackBars.filter(
                (item) => snackbar.id !== item.id
            );
        },
        getProfileReady() {
            this.configReady = false;
            this.permissionMessageTypes.map((item) => {
                this.messageConfigModal["sub"][item] = false;
                this.messageConfigModal["sound"][item] = false;
            });
            if (this.eventSource !== null) {
                this.eventSource.close();
            }
            getPageProfile({ meta_value: "message" })
                .then(({ data }) => {
                    if (data.length) {
                        const profile = data[0];
                        this.profileId = profile["id"];
                        this.allowedMessageTypes = JSON.parse(
                            profile["value"]
                        )?.["allowed_message"];
                        this.allowedSoundTypes = JSON.parse(profile["value"])?.[
                            "allowed_sound"
                        ];
                    } else {
                        this.overlay = false;
                        this.overlayLoading = false;
                    }
                    this.configReady = true;
                })
                .then(() => {
                    setTimeout(() => {
                        this.connectSSE();
                    }, 1000);
                });
            this.showMessageProfileDialog = false;
        },
        muteType(type, duration) {
            const existingMuteUntil = JSON.parse(
                localStorage.getItem(`muteUntil`)
            );

            const currentTime = dayjs().unix();
            let muteUntil = currentTime + 600;
            if (duration === "30 min") {
                muteUntil = currentTime + 1800;
            } else if (duration === "1 hour") {
                muteUntil = currentTime + 3600;
            } else if (duration === "4 hour") {
                muteUntil = currentTime + 14400;
            } else if (duration === "Today") {
                muteUntil = dayjs().endOf("day").unix();
            }
            if (!existingMuteUntil) {
                localStorage.setItem(
                    `muteUntil`,
                    JSON.stringify({ [type]: muteUntil })
                );
            } else {
                const updatedMuteUntil = {
                    ...existingMuteUntil,
                    [type]: muteUntil,
                };
                localStorage.setItem(
                    `muteUntil`,
                    JSON.stringify(updatedMuteUntil)
                );
            }
        },
        unlockAudioOnUserInteraction() {
            unlockAudio();
        },
        redirectTo(type, login, server) {
            let url = "";
            switch (type) {
                case "info":
                    url = `/tag-centre/account-analysis/${server}-${login}`;
                    redirectToRH(url);
                    break;
                case "add":
                    url = `/watch-list?mode=add&login=${login}&server=${server}`;
                    redirectToRH(url);
                    break;
                case "edit":
                    url = `/watch-list?mode=edit&login=${login}`;
                    redirectToRH(url);
                    break;
                default:
                    break;
            }
        },
        calculateOffsets() {
            this.snackBars.forEach((item, index) => {
                const id = item.id;
                let offset = 0;

                for (let i = 0; i < id; i++) {
                    if (this.snackBars.find((bar) => bar.id == i)) {
                        const ref = this.$refs[`snackbar-${i}`];
                        const wrapper = Array.isArray(ref)
                            ? ref[0]?.$el
                            : ref?.$el;

                        const el = wrapper?.querySelector(".v-snack__wrapper");

                        if (el && el.offsetHeight) {
                            offset += el.offsetHeight + 10;
                        }
                    }
                }
                item.offset = offset;
            });
        },
        getAlertMessageHistoryFromApi() {
            const param = {
                mt4_time: dayjs()
                    .tz("US/Eastern")
                    .add(7, "hour")
                    .add(-1, "day")
                    .format("YYYY-MM-DD HH:mm:ss"),
            };

            getAlertMessageHistory(param)
                .then(({ data }) => {
                    this.alertMessagePool = data;
                    this.showAlertMessagePool = true;
                })
                .finally(() => {
                    this.historyLoading = false;
                });
        },
        computedType(type) {
            switch (type) {
                case "Position Total Alert":
                    return "Total Position";
                case "Position Change Alert":
                    return "Position Change";
                case "PNL Total Alert":
                    return "Total PNL";
                case "PNL Change Alert":
                    return "PNL Change";
                case "Market News Alert":
                    return "Market News";
                default:
                    return type;
            }
        },
        openRatingModal(type) {
            this.isRatingModalOpen = true;
            this.ratingModalType = type;
        },
        closeModal(data) {
            this.isRatingModalOpen = false;
            if (data) {
                const { rating, type } = data;
                this.modalData[type] = rating;
            }
        },
        fetchRecheckStatus() {
            recheckTaskStatus().then(({ data }) => {
                this.recheckHistoryItems = data;
            });
        },
    },
    mounted() {
        if (this.pumpingStatusTimer !== null) {
            clearInterval(this.pumpingStatusTimer);
        }
        this.checkPumpingStatus();
        this.pumpingStatusTimer = setInterval(
            () => this.checkPumpingStatus(),
            30 * 1000
        );
        const accountChild = this.getChild("account");

        if (accountChild.includes("management")) this.loadManagement = 1;
        if (accountChild.includes("permission")) this.loadPermission = 1;
        if (accountChild.includes("config")) this.loadSettings = 1;
        if (accountChild.includes("profile")) this.loadSecurity = 1;

        this.profileUpdate.home = false;
        this.profileUpdate.alert = false;
        this.logoutLoading = false;
        setTimeout(() => {
            this.updateWidth();
            this.onScreenResize();
            document
                .getElementById("timeDiv")
                ?.addEventListener("scroll", () => {
                    this.checkMovability();
                });
        }, 1200);

        this.fetchRecheckStatus();
        this.recheckInterval = setInterval(() => {
            this.fetchRecheckStatus();
        }, 60 * 1000);
    },
    destroyed() {
        clearInterval(this.pumpingStatusTimer);
        clearInterval(this.recheckInterval);
        if (this.eventSource !== null) {
            this.eventSource.close();
        }
        this.snackBars = [];
    },
    created() {
        this.getLotDigitsAction();
        this.getServerAction();
        // if (!this.VUETIFY_BREAKPOINT.mobile) {
        // getHolidayData().then((res) => {
        //     const filtered = res?.data.filter((item) => item.enable === 1);
        //     const symbolOptions = [];
        //     const yearOptions = [];
        //     !!filtered && filtered.forEach((item) => {
        //         item.date =
        //             item.year +
        //             "-" +
        //             item.month +
        //             "-" +
        //             item.day +
        //             ", " +
        //             this.dayOfWeek[
        //                 dayjs(
        //                     item.year + "-" + item.month + "-" + item.day
        //                 ).day()
        //             ];
        //         if (!symbolOptions.includes(item.symbol)) {
        //             symbolOptions.push(item.symbol);
        //         }
        //         if (!yearOptions.includes(item.year)) {
        //             yearOptions.push(item.year);
        //         }
        //         this.symbolOptions = List(symbolOptions);
        //         this.yearOptions = List(yearOptions);
        //     });
        //     this.holidayData = filtered;
        // });
        // }
        const permission = JSON.parse(localStorage.getItem("permission"));
        const enableAlertMessage =
            permission?.frontPermission?.alertMessage?.child?.includes(
                "enableAlertMessagePumping"
            );

        this.enableAlertMessage = enableAlertMessage;
        this.showLanguageSwitch =
            permission?.frontPermission?.book?.function?.includes(
                "enableLanguageSwitch"
            );

        this.isRiskRatingAllowed =
            permission?.frontPermission?.alertMessage?.child?.includes(
                "enableRiskRating"
            );

        if (enableAlertMessage) {
            // permission level allowed message type
            const permissionMessageTypes = JSON.parse(
                localStorage.getItem("permission")
            )?.frontPermission?.alertMessage?.child?.filter(
                (item) =>
                    item !== "enableAlertMessagePumping" &&
                    item !== "enableRiskRating"
            );
            this.permissionMessageTypes = permissionMessageTypes;
            this.getProfileReady();
        } else {
            this.overlay = false;
            this.overlayLoading = false;
        }

        if (permission?.frontPermission?.lp?.child) {
            this.drawerRouteList.push({
                path: "/lp/mobile",
                label: "Lp",
            });
        }
        if (permission?.frontPermission?.alert?.child?.includes("overview")) {
            this.drawerRouteList.push({
                path: "/alert/mobile",
                label: "Alert",
            });
        }
    },
};
</script>

<style lang="scss" scoped>
div >>> .v-application--wrap {
    min-height: calc(100vh - 40px);
}
div >>> .v-dialog {
    overflow: hidden;
}
div >>> .v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

div.scrollmenu {
    overflow: overlay;
    white-space: nowrap;
}
div.scrollmenu::-webkit-scrollbar {
    display: none;
}

div.scrollmenu div {
    display: inline-block;
    color: white;
    text-align: center;
    padding: 14px;
    text-decoration: none;
}
.pumpingStatusTooltip.v-tooltip__content.menuable__content__active {
    opacity: 1 !important;
}

::v-deep {
    .v-toolbar__content {
        justify-content: space-between;
    }
    .v-navigation-drawer__content {
        overflow-y: hidden;
    }
    .customizedSnackbar {
        color: black;
    }
    .v-dialog {
        overflow-y: hidden;
    }
}
.snackbar-icon {
    font-size: 20px;
}
::v-deep(.v-snack__content) {
    width: 100%;
}
.datetimeDisplay {
    text-align: end;
    padding-top: 2px;
}
@keyframes alarm-shake {
    0% {
        transform: rotate(0deg);
    }
    5% {
        transform: rotate(-12deg);
    }
    10% {
        transform: rotate(12deg);
    }
    15% {
        transform: rotate(-10deg);
    }
    20% {
        transform: rotate(10deg);
    }
    25% {
        transform: rotate(-8deg);
    }
    30% {
        transform: rotate(8deg);
    }
    35% {
        transform: rotate(-6deg);
    }
    40% {
        transform: rotate(6deg);
    }
    45% {
        transform: rotate(-4deg);
    }
    50% {
        transform: rotate(4deg);
    }
    60% {
        transform: rotate(-2deg);
    }
    70% {
        transform: rotate(2deg);
    }
    100% {
        transform: rotate(0deg);
    }
}

.alarm-2s {
    transform-origin: top center;
    animation: alarm-shake 2s cubic-bezier(0.36, 0.07, 0.19, 0.97);
}
::v-deep(.html-content table) {
    width: 100%;
    border-collapse: collapse;
}
::v-deep(.html-content th),
::v-deep(.html-content td) {
    border: 1px solid #ddd;
    padding: 6px 8px;
    text-align: left;
    vertical-align: top;
}
::v-deep(.html-content th) {
    font-weight: 600;
}
</style>
